//format the text as a decimal or can use as a currency with changing the style to currency and add currency parametre
export function CurrencyFormatter(
  value,
  locale = "en-US",
  minFraction = 2,
  maxFraction = 2
) {
  const formattedValue = new Intl.NumberFormat(locale, {
    style: "decimal",
    minimumFractionDigits: minFraction,
    maximumFractionDigits: maxFraction,
  }).format(value);

  return formattedValue;
}

export function StockTypeSecondaryCodeFormatter(secondaryCode) {
  const code =
    secondaryCode.toString().substring(0, 16) +
    secondaryCode.toString().slice(-5);

  return code;
}
